/*
Sohel 09/19/2022 3075154998 Data Manager Matching Logic ->Integrated API,Added System Notes and Suggested Changes
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';

const initialState = {
  addMatchingLogicStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  MatchingLogicData: {},
  isSystemNoteLoading: false,
  systemNotesStatus: null,
  notesuccessMsg: null,
  filterGroupCodeData: [],
  clientCodeDropdownData: [],
  formulaRuleData: [],
};

const filterGroup = createSlice({
  name: 'dmMatchingLogic',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postMatchingLogic: (state, action) => {
      state.addMatchingLogicStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    fetchMatchingLogic: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.MatchingLogicData = action.payload;
    },
    fetchFilterGroupCodeData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.filterGroupCodeData = action.payload;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.notesuccessMsg = action.payload.message;
      state.isSystemNoteLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    getclientCodeData: (state, action) => {
      state.clientCodeDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getFormulaRuleData: (state, action) => {
      state.formulaRuleData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addMatchingLogicStatus = null;
      state.MatchingLogicData = {};
    },
    resetNoteMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
      state.notesuccessMsg = null;
    },
    resetMatchingLogic: (state) => {
      state.MatchingLogicData = {};
    },
  },
});

export default filterGroup.reducer;

const {
  fetchStart,
  fetchError,
  postMatchingLogic,
  resetMsg,
  fetchMatchingLogic,
  resetMatchingLogic,
  fetchNoteStart,
  postSystemNotesData,
  resetNoteMessage,
  fetchFilterGroupCodeData,
  getFormulaRuleData,
  getclientCodeData,
} = filterGroup.actions;

export const postMatchingLogicData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`matchinglogic/save/matchinglogic`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postMatchingLogic(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchMatchingLogicData = (matchingLogicCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`matchinglogic/find/matchinglogicblock/${matchingLogicCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchMatchingLogic(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchFilterGroupCode = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfiltergroup/find/all/filtergroupcodeanddescription`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchFilterGroupCodeData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`matchinglogic/save/matchinglogicnotes`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getClientCodeDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/all/clientcodeandnames`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getclientCodeData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const getFormulaRuleDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/all/brecode`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFormulaRuleData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetMatchingLogicData = () => {
  return (dispatch) => {
    dispatch(resetMatchingLogic());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetNoteMessage());
  };
};
